<template>
    <div class="container">
        <div @click="start(item)" class="prize-item" :dd='item.giftId' :ddd='item.name'
            v-for="(item, index) in giftList" :key="index" :class="[activeIndex === index? 'active':'']">
            <img :src="item.img" alt="" class="prize-pic" v-if="item.giftId !== 0" />
            <div class="prize-num" @click="start(item)" v-else>{{ canRunCount }}次机会</div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api'

export default {
    name: 'Choujiang',
    props: {
        canRunCount: {
            type: [Number, String],
            default: 0
        },
        giftList: {
            type: [Array],
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            allowChoujiang: true,
            activeIndex: 1,

            cicles: 0, //定义圈数
            time: 200, //定义速度
        }
    },
    mounted () {
        let self = this;
    },
    methods: {
        /**
         * 开始抽奖
         * @param { }
         */
        async start (item) {
            let self = this;
            if (item.giftId !== 0) return;

            if (self.canRunCount == 0) {
                self.$emit('handleResult', 0);
                return false;
            }
            if (!self.allowChoujiang) {
                return false;
            }
            self.allowChoujiang = false;

            let res = await api('post', '/run').catch(err => {
                self.allowChoujiang = true;
                // console.log(err)
            })

            let { data, code, msg } = res && res.data;
            console.log(data, code, msg)
            self.allowChoujiang = true;

            if (code == 200) {
                self.canRunCount = self.canRunCount - 1;
                console.log(self.giftList)
                //停止时的位置
                var stopIdx = -1;
                for(var i=0;i<self.giftList.length;i++){
                    if(self.giftList[i].giftId == data.giftId){
                        stopIdx = i;
                        break;
                    }
                }
                if(stopIdx == -1){//如果没找到奖品则将停止位置设置到空奖上
                    for(var i=0;i<self.giftList.length;i++){
                        if(self.giftList[i].type == 1){
                            stopIdx = i;
                            break;
                        }
                    }
                }   
                //输出结果
                console.log('当前停止位置:' + stopIdx)             
                self.startView(self.activeIndex, stopIdx, () => {
                    self.cicles = 0;
                    self.time = 200;
                    
                    setTimeout(() => {
                        self.$emit('handleResult', data);
                    }, 1000);
                })
            } else if (code == 181) {
                self.$message.warning("活动还未开始")
            }
            else if (code == 182) {
                self.$message.warning("活动已经结束")
            } else {
                self.$message.warning(msg || "数据异常")
            }
        },
        startView (selectIndex, stopIndex, fn) {
            // console.log(this.activeIndex, selectIndex, this.time)
            if (this.activeIndex === selectIndex && this.cicles < 3) {
                //圈数+1
                this.cicles += 1
                //速度加快
                this.time -= 50
            }
            if (this.activeIndex === selectIndex && this.cicles >= 3) {
                this.cicles += 1
                //圈数>4时速度减慢
                this.time += 50
            }
            if (this.cicles > 7 && this.activeIndex === stopIndex) {
                //圈数为8时停止
                fn()
                return
            }
            let timer = setTimeout(() => {
                //定时器轮询
                //计算下一个位置索引
                var newIdx = 0;
                switch(this.activeIndex){
                    case 0:newIdx = 1; break;
                    case 1:newIdx = 2; break;
                    case 2:newIdx = 5; break;
                    case 3:newIdx = 0; break;
                    case 5:newIdx = 8; break;
                    case 6:newIdx = 3; break;
                    case 7:newIdx = 6; break;
                    case 8:newIdx = 7; break;
                }
                this.activeIndex = newIdx;
                //每走一步清除定时器再递归调用，实现连续效果
                clearTimeout(timer)
                this.startView(selectIndex,stopIndex, fn)
            }, this.time)
        },
    },
}
</script>

<style scoped lang="less">
@page-width: 750;

.container {
    width: unit(579 / @page-width * 100, vw);
    height: unit(579 / @page-width * 100, vw);
    position: absolute;
    top: unit(516 / @page-width * 100, vw);
    left: unit(86 / @page-width * 100, vw);
    // background-color: aliceblue;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.container .prize-item {
    position: relative;
    width: unit(193 / @page-width * 100, vw);
    height: unit(193 / @page-width * 100, vw);
    // background-color: #fffdfa;
    border-radius: 20px;
    box-sizing: border-box;
    // box-shadow: 0px 0px 10px #fcb696 inset;
    background-image: url(../../assets/image/n10.png);
    background-size: 100% 100%;
    margin: 0 unit(0 / @page-width * 100, vw) unit(0 / @page-width * 100, vw) 0;
    // border: 3px solid #fcb696 ;

}

.container .prize-item:nth-child(5) {
    background-image: url(../../assets/image/n11.png);
}

.container div span {
    font-size: 30px;
}

.container .prize-item.active {

    background-image: url(../../assets/image/n11.png);
    background-size: 100% 100%;

}

.container .prize-item:nth-child(5) {
    background-image: url(../../assets/image/n12.png);
}

.prize-pic {
    width: 100%;
    height: 100%;
}

.prize-num {
    color: #9b1824;
    font-size: 14px;
    position: absolute;
    bottom: 10%;
    left: 0;
    width: 100%;
    text-align: center;

}
</style>